export default {
  boxShadow: {
    boxShadow: '1px 1px 4px #888888'
  }
};
